import { call, put, takeEvery } from "redux-saga/effects";

import {
  TICKET_LIST,
  TICKET_CREATE,
  TICKET_FILTER,
  TICKET_UPDATE,
  CONSIGNMENT_CREATE,
  INVOICE_CREATE,
  INVOICE_UPDATE,
  CONFISCATION_CREATE,
} from "store/billing/actionTypes";

import {
  ticketListSuccess,
  ticketCreateSuccess,
  ticketUpdateSuccess,
  consignmentCreateSuccess,
  invoiceCreateSuccess,
  invoiceUpdateSuccess,
  confiscationCreateSuccess,
  billingRequestFailed,
} from "store/billing/actions";

import {
  getTicketList,
  postTicketCreate,
  getTicketFilter,
  patchTicketUpdate,
  postConsignment,
  postInvoiceCreate,
  patchInvoiceUpdate,
  postConfiscationCreate,
} from "connection/backend";

function* ticketListSaga() {
  console.log("Trayendo lista de tickets...");
  try {
    const response = yield call(getTicketList);
    if (response.status === 200) {
      yield put(ticketListSuccess(response.data));
    } else {
      yield put(billingRequestFailed(response.data));
    }
  } catch (error) {
    yield put(billingRequestFailed(error.response.data));
  }
}

function* ticketCreateSaga({ payload: ticket }) {
  console.log("Creando nuevo ticket...");
  try {
    const response = yield call(postTicketCreate, ticket);
    if (response.status === 201) {
      yield put(ticketCreateSuccess(response.data));
    } else {
      yield put(billingRequestFailed(response.data));
    }
  } catch (error) {
    yield put(billingRequestFailed(error.response.data));
  }
}

function* ticketFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getTicketFilter, { changeUrl });
    if (response.status === 200) {
      yield put(ticketListSuccess(response.data));
    } else {
      yield put(billingRequestFailed(response.data));
    }
  } catch (error) {
    yield put(billingRequestFailed(error.response.data));
  }
}

function* ticketUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando ticket...");
  try {
    const response = yield call(patchTicketUpdate, { id }, data);
    if (response.status === 200) {
      yield put(ticketUpdateSuccess(response.data));
    } else {
      yield put(billingRequestFailed(response.data));
    }
  } catch (error) {
    yield put(billingRequestFailed(error.response.data));
  }
}

function* consignmentCreateSaga({ payload: consignment }) {
  console.log("Creando nueva consignación...");
  try {
    const response = yield call(postConsignment, consignment);
    if (response.status === 201) {
      yield put(consignmentCreateSuccess(response.data));
    } else {
      yield put(billingRequestFailed(response.data));
    }
  } catch (error) {
    yield put(billingRequestFailed(error.response.data));
  }
}

function* invoiceCreateSaga({ payload: invoice }) {
  console.log("Creando nueva factura...");
  try {
    const response = yield call(postInvoiceCreate, invoice);
    if (response.status === 201) {
      yield put(invoiceCreateSuccess(response.data));
    } else {
      yield put(billingRequestFailed(response.data));
    }
  } catch (error) {
    yield put(billingRequestFailed(error.response.data));
  }
}

function* invoiceUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando autorización...");
  try {
    const response = yield call(patchInvoiceUpdate, { id }, data);
    if (response.status === 200) {
      yield put(invoiceUpdateSuccess(response.data));
    } else {
      yield put(billingRequestFailed(response.data));
    }
  } catch (error) {
    yield put(billingRequestFailed(error.response.data));
  }
}

function* confiscationCreateSaga({ payload: confiscation }) {
  console.log("Registrando lista de decomisos...");
  try {
    const response = yield call(postConfiscationCreate, confiscation);
    if (response.status === 201) {
      yield put(confiscationCreateSuccess(response.data));
    } else {
      yield put(billingRequestFailed(response.data));
    }
  } catch (error) {
    yield put(billingRequestFailed(error.response.data));
  }
}

export default function* billingSaga() {
  yield takeEvery(TICKET_LIST, ticketListSaga);
  yield takeEvery(TICKET_CREATE, ticketCreateSaga);
  yield takeEvery(TICKET_FILTER, ticketFilterSaga);
  yield takeEvery(TICKET_UPDATE, ticketUpdateSaga);
  yield takeEvery(CONSIGNMENT_CREATE, consignmentCreateSaga);
  yield takeEvery(INVOICE_CREATE, invoiceCreateSaga);
  yield takeEvery(INVOICE_UPDATE, invoiceUpdateSaga);
  yield takeEvery(CONFISCATION_CREATE, confiscationCreateSaga);
}
